import { getCache } from './cache';

export interface SetValueInCacheInput<T> {
  key: string;
  value: T;
}

export const setValueInCache = <T>({ key, value }: SetValueInCacheInput<T>) => {
  getCache().set(key, value);
};

export const getValueFromCache = <T>(key: string): T | undefined => {
  return getCache().get(key) as T | undefined;
};
